<template>
  <div class="vsm-shell" style="margin-top: 20px">

    <!-- Marketing pitch for tenants without VSM access -->
    <feature-upsell
      v-if="!vsmAccessGranted"
      icon="fa-bus"
      headline="Vehicle Status Manager"
      sub="Vehicle Status Manager isn't enabled for your account yet. It gives your team a live view of every vehicle in the fleet and its readiness for dispatch."
      :items="upsellItems"
      category="vsm"
      subject="I'd like to sign up for Vehicle Status Manager"
    />

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { hasVsmAccess as checkVsmAccess, vsmRouteName } from '../utils/vsm_access'
import FeatureUpsell from './feature_upsell'

const UPSELL_ITEMS = [
  { label: 'Live fleet readiness', desc: 'Track OUT, READY, CLEAN, DIRTY, OOS, and PM statuses at a glance.' },
  { label: 'SMS status updates', desc: 'Wash and maintenance staff can update vehicle status by text message.' },
  { label: 'Departure schedule', desc: 'Prioritize cleaning and spot vehicles that need swapping before upcoming bookings.' },
  { label: 'DVIR and maintenance', desc: 'Optional integration with pre-trip inspections and shop workflows.' },
]

export default {
  name: 'vsm_shell',
  components: { FeatureUpsell },
  data() {
    return { upsellItems: UPSELL_ITEMS }
  },
  computed: {
    ...mapState({
      user: state => state.profile.user,
    }),
    features() { return this.user.features[this.user.tenant] || {} },
    tenant_type() { return this.user.types[this.user.tenant] },
    vsmAccessGranted() { return checkVsmAccess(this.features) },
  },
  mounted() {
    if (this.vsmAccessGranted && this.$route.name === 'vehstatusmgr') {
      this.$router.replace({ name: vsmRouteName(this.tenant_type, this.features) })
    }
  },
}
</script>
